export default class FormStyler {
  constructor(elementSelector) {
    this.elements = document.querySelectorAll(elementSelector);
    this.init();
  }

  init() {
    if (this.elements) {
      this.elements.forEach((element) => {

        //if 'SELECT'
        if (element.nodeName === 'SELECT') {
          const options = element.querySelectorAll('option'),
            selectParent = element.parentElement,
            newWrapper = document.createElement('div'),
            selectDropdown = document.createElement('div'),
            selectDropdownList = document.createElement('ul');

          newWrapper.classList.add('jq-selectbox', 'jqselect');
          selectDropdown.classList.add('jq-selectbox__dropdown');

          //Creating new options
          options.forEach((option, index) => {
            const listItem = document.createElement('li');

            listItem.textContent = option.textContent;
            if (index === 0) {
              listItem.classList.add('selected');
            }
            selectDropdownList.append(listItem);
          });

          //Formation of the correct structure of elements
          newWrapper.append(element);
          newWrapper.insertAdjacentHTML('beforeend', `<div class="jq-selectbox__select">
            <div class="jq-selectbox__select-text">${element.value}</div>
          </div>`);
          selectDropdown.append(selectDropdownList);
          newWrapper.append(selectDropdown);

          //Append new elements to the page
          selectParent.append(newWrapper);

          //Open Dropdown
          newWrapper.addEventListener('click', (event) => {
            if (event.target.nodeName === 'LI') {
              const thisParentSelectBox = event.target.closest('.jq-selectbox');
              thisParentSelectBox.querySelector('.jq-selectbox__dropdown li.selected').classList.remove('selected');
              thisParentSelectBox.querySelector('.jq-selectbox__select-text').textContent = event.target.textContent;
              thisParentSelectBox.querySelector('select').value = event.target.textContent;
              event.target.classList.add('selected');
            }
            newWrapper.classList.toggle('opened');
          });
        }

      });

      //Close Dropdown
      document.addEventListener('click', (event) => {
        const openedSelectBox = document.querySelector('.jq-selectbox.opened');
        if (openedSelectBox && !openedSelectBox.contains(event.target)) {
          openedSelectBox.classList.remove('opened');
        }
      });
    }
  }
}
